/**
 * The signup payload never carries a coordinate the user did not choose.
 *
 * `lat`/`lon` are filled from a suggestion picked in the address list. When the
 * geocoder is unreachable the user types the address by hand and the form still
 * holds its initial `0`/`0`; sending that would place the account in the Gulf of
 * Guinea and distort every distance-based feature. The API accepts the fields as
 * optional, so they are omitted instead.
 */
export const buildSignUpPayload = <
  T extends { lat?: number | null; lon?: number | null }
>(
  form: T
): T => {
  const { lat, lon, ...rest } = form;

  const hasCoordinates =
    typeof lat === "number" &&
    typeof lon === "number" &&
    (lat !== 0 || lon !== 0);

  return (hasCoordinates ? { ...rest, lat, lon } : rest) as T;
};
